export interface CsvImportClientError {
  name?: string;
  errorFields: ClientErrorField[];
}

export interface CsvImportClientsErrorResponse {
  importErrors: CsvImportClientError[];
}

export enum ClientErrorField {
  NAME = 'NAME',
}
